import { useTranslation } from 'react-i18next'

import { Switch, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CopyTitle = ({ label, isActive, onCheck }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="bodyMBold">{label}</Text>
      <Switch checked={isActive} label={t('Usar mensaje personalizado')} onChange={onCheck} />
    </Styles.Container>
  )
}

export default CopyTitle
